import {Pipe, PipeTransform} from '@angular/core';
import {ProductService} from "../product/product.service";

@Pipe({
    name: 'cryptosymbol2name',
    standalone: false
})
export class CryptoSymbol2NamePipe implements PipeTransform {

  constructor(protected productService: ProductService) {

  }

  public async transform(symbol: string) {
    let returnValue = null;

    let product = await this.productService.getProduct(symbol);
    if(product != null) {
      returnValue = product.name;
    }

    return returnValue;
  }

}

